import React from 'react';
import { withRouter } from 'next/router'

function ActiveLink({ children, router, href }) {
    const style = {
        color:'#FFFFFF',
        backgroundColor:"#c61732",
        borderRadius: "5px"
    };

    const handleClick = (e) => {
        e.preventDefault();
        router.push(href)
    };


    if(router.pathname === href)
    {
        return (
        <a href={href} onClick={handleClick} style={style}>
            {children}
        </a>
        )
    }
    else {
        return <a href={href} onClick={handleClick}>
            {children}
        </a>
    }

}

export default withRouter(ActiveLink)